<!-- clase box -->
<div
  class="subbasicbox chat"
  [ngClass]="{
    active: chats[chatUrl]?.active,
    nuevomensaje: chats[chatUrl]?.nuevomessage
  }"
>
  <div class="notificaciones" *ngIf="totalNotifications > 0">
    {{ totalNotifications }}
  </div>
  <div class="boximage">
    <a routerLink="/dashboard/mensajes/chat/{{ chatUrl }}">
      <img
        *ngIf="chatUser?.avatar; else defaultheadavatar"
        src="{{ chatUser?.avatar }}"
        alt="{{ chatUserFullName | titlecase }}"
      />
      <ng-template #defaultheadavatar>
        <img
          src="assets/img/defaultavatar.jpg"
          alt="{{ chatUserFullName | titlecase }}"
        />
      </ng-template>

      <div
        class="status"
        [ngClass]="{
          online: presence === 'online',
          away: presence === 'away',
          '': presence === 'offline'
        }"
      ></div>
    </a>
  </div>
  <div class="boxtitles">
    <h4>
      {{ chatUserFullName | titlecase }}
    </h4>
    <ng-container *ngIf="disconnectedTime">
      <p translate [translateParams]="{ disconnectedTime: disconnectedTime }">
        dashboard.clase.editarC.activo
      </p>
    </ng-container>
  </div>
  <div>
    <div class="boxchatvideocall">
      <a
        href="https://access.colegia.education/webapp3/#/?conference={{
          chatUserUsername | titlecase
        }}&name={{ mainUserFirstName | titlecase }} {{
          mainUserLastName | titlecase
        }}&role=guest&callType=video&join=1"
        target="_blank"
      >
        <img src="assets/img/videocall.svg" />
      </a>
    </div>
  </div>

  <div class="boxdata">
    <div class="lastchat">
      <p>{{ lastChatMessage?.message | slice : 0 : 13 }}</p>
    </div>
  </div>

  <div class="boxclose">
    <div class="close">
      <a (click)="toggleDeletePopup()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="11.513"
          height="8.063"
          viewBox="0 0 11.513 8.063"
        >
          <g
            id="Grupo_9481"
            data-name="Grupo 9481"
            transform="translate(-5.602 -5.601)"
          >
            <path
              id="Trazado_9279"
              data-name="Trazado 9279"
              d="M17.115,9.633Z"
              fill="#2D3453"
            />
            <path
              id="Trazado_9280"
              data-name="Trazado 9280"
              d="M16.889,9.164a.575.575,0,0,0-.814,0l0,0-3.045,3.05L9.982,9.164a.578.578,0,0,0-.817.817l3.05,3.045-3.05,3.045a.578.578,0,0,0,.817.817l3.045-3.05,3.045,3.05a.578.578,0,0,0,.817-.817l-3.05-3.045,3.05-3.045a.575.575,0,0,0,0-.814Z"
              transform="translate(-3.394 -3.393)"
              fill="#2D3453"
            />
          </g>
        </svg>
      </a>
    </div>
  </div>
</div>
<div *ngIf="showDeletePopup == true">
  <div class="borrarPop">
    <img
      id="close"
      src="assets/img/close.svg"
      alt="close"
      (click)="toggleDeletePopup()"
    />
    <p translate>dashboard.mensajes.popborrar</p>
    <button
      class="button"
      (click)="deleteChat(mainUserId, chatUser?.uid)"
      translate
    >
      dashboard.mensajes.borrar
    </button>
  </div>
</div>
<!--/clase box -->
